<template>
    <svg class="bar-chart" :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
        <g :transform="'translate('+margin.left+','+margin.top+')'">
            <g class="axis">
                <g ref="yAxis"></g>
                <g ref="xAxis" :transform="'translate(0,'+chartHeight+')'"></g>
            </g>
            <g v-for="d in data">
                <title>{{d[dimensions.time[0]]}}: {{d.sum}}</title>
                <rect :y="y(d.sum)" :height="chartHeight - y(d.sum)" :x="x(d[dimensions.time[0]])" :width="x.bandwidth()" :fill="color(d[dimensions.time[0]])"></rect>
            </g>
        </g>
    </svg>
</template>
<script>
    import * as d3 from 'd3';
    import numeral from 'numeral';

    export default{
        data: function(){
            return {
                width: 825,
                height: 510,
                margin:{
                    left: 100,
                    top: 10,
                    right: 10,
                    bottom: 20
                }
            }
        },
        props:['data', 'dimensions'],
        computed:{
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },
            x: function(){
                return d3.scaleBand()
                    .paddingInner(0.2)
                    .range([0, this.chartWidth])
                    .domain(this.data.map((d)=>{return d[this.dimensions.time[0]]}));
            },
            y: function(){
               return d3.scaleLinear()
                   .range([this.chartHeight, 0])
                   .domain([0, d3.max(this.data, function(d){return d.sum})]);
            },
            color: function(){
                return d3.scaleOrdinal(d3.schemeCategory10);
            },
            axisLeft: function(){
                return d3.axisLeft(this.y)
                    .tickFormat((d)=>{
                        return numeral(d).format('0,0');
                    });
            },
            axisBottom: function(){
                return d3.axisBottom(this.x);
            }
        },
        watch:{
            data: function(){
                d3.select(this.$refs.yAxis).call(this.axisLeft);
                d3.select(this.$refs.xAxis).call(this.axisBottom);
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Bar.vue